// Component imports

const {default: btn} = require( '../components/common/btn' );


// Initialize components
document.addEventListener( "DOMContentLoaded", () => {
	btn.init();
} );